/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectRetrofitConfiguration, selectPartnerPreferences } from "../../../Retrofit/store/slices/retrofit";
import { logEvent } from "../../utils/api/api";
import CustomPopup from "../CustomPopup/CustomPopup";
import Button from "../Buttons/Button/Button";
import t from "../../utils/translation/translator";
import { selectEventsData } from "../../store/slices/common";

const ProductDataSheetLink = ({ reference, eventTag, idLabel }) => {
  const locale = window.msizerConfiguration?.locale || "en-WW";
  const localeLowerCase = locale.toLowerCase();
  const splitLocaleLowerCase = localeLowerCase.split("-");
  const lang = splitLocaleLowerCase[0];
  const country = splitLocaleLowerCase[1] === "gb" ? "uk" : splitLocaleLowerCase[1];

  const partnerPreferences = useSelector(selectPartnerPreferences);
  const eventsData = useSelector(selectEventsData);
  const configuration = useSelector(selectRetrofitConfiguration);

  const [showDownloadDataSheetPopup, setShowDownloadDataSheetPopup] = useState(false);

  const openProductDataSheetPDF = () => {
    setShowDownloadDataSheetPopup(false);
    window.open(
      `https://download.schneider-electric.com/files?p_File_Name=${reference}_DATASHEET_${
        country.toUpperCase() === "UK" ? "GB" : country.toUpperCase()
      }_${lang}-${country.toUpperCase() === "UK" ? "GB" : country.toUpperCase()}.pdf`,
      "_blank"
    );
  };

  const downloadProductDataSheetPDF = () => {
    setShowDownloadDataSheetPopup(false);
    window.open(`https://www.se.com/${country}/${lang}/product/download-pdf/${reference}`, "_blank");
  };

  function generateAndOpenURLByTemplate(template, obj) {
    if (!obj || !Object.keys(obj).length) {
      throw new Error("Please provide required parameter.");
    }
    let finalLink = template;
    Object.keys(obj).forEach((prop) => {
      if (obj[prop] && finalLink.includes(prop)) {
        finalLink = finalLink.replace(new RegExp(`{{${prop}}}`, "g"), obj[prop]);
      }
    });
    window.open(finalLink, "_blank");
  }

  const handleOpenProductDataSheet = (e) => {
    e.stopPropagation();
    logEvent(eventsData.locale, eventsData.types.openProduct, eventTag, configuration?.configId);

    if (partnerPreferences === null) {
      // open getProductDataSheetLink in new tab
      window.open(`https://www.se.com/${country}/${lang}/product/${reference}`, "_blank");
    } else {
      const datasheetTemplate = partnerPreferences?.dataSheetTemplate;
      if (datasheetTemplate) {
        // dataSheetTemplate pattern ”https://mywebsite/{{intl.countryCode}}/{{intl.languageCode}}/products/{{productId}}”
        const params = {
          productId: reference,
          "intl.countryCode": country,
          "intl.languageCode": lang
        };
        generateAndOpenURLByTemplate(datasheetTemplate, params);
      } else {
        setShowDownloadDataSheetPopup(true);
      }
    }
  };
  return (
    <>
      <span id={`retrofit-specify-ref-${idLabel}`} onClick={(e) => handleOpenProductDataSheet(e)}>
        {reference}
      </span>
      <CustomPopup
        title={t("msizer.ui.popup.download_product_datasheet.title")}
        opened={showDownloadDataSheetPopup}
        onClose={() => {
          setShowDownloadDataSheetPopup(false);
        }}
        closeOnDocumentClick={false}
      >
        <div className="flex flex-col space-y-2">
          <Button
            className="flex-1 py-2 mx-10 bg-secondary text-secondaryTextColor hover:bg-hoverSecondary hover:text-secondaryHoverTextColor"
            onClick={() => downloadProductDataSheetPDF()}
            primary
            large
          >
            {t("msizer.ui.popup.download_product_datasheet.download_pdf")}
          </Button>
          <Button
            className="flex-1 py-2 mx-10 bg-secondary text-secondaryTextColor hover:bg-hoverSecondary hover:text-secondaryHoverTextColor"
            onClick={() => openProductDataSheetPDF()}
            primary
            large
          >
            {t("msizer.ui.popup.download_product_datasheet.open_pdf_in_new_tab")}
          </Button>
        </div>
      </CustomPopup>
    </>
  );
};

ProductDataSheetLink.propTypes = {
  reference: PropTypes.string.isRequired,
  eventTag: PropTypes.string.isRequired,
  idLabel: PropTypes.string.isRequired
};

export default ProductDataSheetLink;
